import { Icon } from "@circleco/compass/components/Icon";
import { Popover } from "@circleco/compass/components/Popover";
import { Tooltip } from "@circleco/compass/components/Tooltip";
import { useState } from "react";

import { t } from "@/i18n-js/instance";

import { CommunityHeaderRows } from "./CommunityHeaderRows";
import { useCommunityHeader } from "./useCommunityHeaderRows";

export const CircleAIDockCommunityHeaderExpanded = () => {
  const { canGoBack, communityName, currentAvatar, goBackToCommunity, rows } =
    useCommunityHeader();
  const [isOpen, setIsOpen] = useState(false);

  const trigger = (
    <button
      type="button"
      aria-label={communityName}
      className="flex min-h-9 w-full items-center gap-3 rounded-md border border-primary bg-primary px-2 py-1.5 text-left transition-colors duration-150 ease-linear hover:bg-secondary"
    >
      <span aria-hidden className="size-6 shrink-0" />
      <span className="flex-1 truncate text-sm font-medium text-dark">
        {communityName}
      </span>
      <Icon
        name="chevron-down"
        size="sm"
        className="shrink-0"
        color="secondary"
      />
    </button>
  );

  return (
    <div className="relative px-3 pt-4">
      <Popover
        trigger={trigger}
        open={isOpen}
        onOpenChange={setIsOpen}
        side="bottom"
        align="start"
        className="max-h-[calc(100vh-2rem)] !p-0"
      >
        <div className="max-h-[calc(100vh-2rem)] overflow-y-auto">
          <CommunityHeaderRows
            rows={rows}
            onRowClick={row => {
              if (row.closeOnClick !== false) setIsOpen(false);
            }}
          />
        </div>
      </Popover>
      {canGoBack ? (
        <Tooltip content={t("admin_nav_v4.back_to_community")} side="bottom">
          <button
            type="button"
            aria-label={t("admin_nav_v4.back_to_community")}
            onClick={goBackToCommunity}
            className="group/back absolute left-[22px] top-[22px] flex size-6 shrink-0 items-center justify-center rounded-md transition-colors duration-150 ease-linear hover:bg-tertiary"
          >
            <span className="ease-[cubic-bezier(0.23,1,0.32,1)] absolute inset-0 flex items-center justify-center transition-[opacity,transform] duration-150 group-hover/back:-translate-x-0.5 group-hover/back:opacity-0 group-focus-visible/back:-translate-x-0.5 group-focus-visible/back:opacity-0 motion-reduce:transform-none motion-reduce:transition-opacity">
              {currentAvatar}
            </span>
            <span className="ease-[cubic-bezier(0.23,1,0.32,1)] absolute inset-0 flex translate-x-0.5 items-center justify-center opacity-0 transition-[opacity,transform] duration-150 group-hover/back:translate-x-0 group-hover/back:opacity-100 group-focus-visible/back:translate-x-0 group-focus-visible/back:opacity-100 motion-reduce:transform-none motion-reduce:transition-opacity">
              <Icon name="arrow-left" size="sm" color="primary" />
            </span>
          </button>
        </Tooltip>
      ) : (
        <span className="absolute left-[22px] top-[22px] flex size-6 shrink-0 items-center justify-center">
          {currentAvatar}
        </span>
      )}
    </div>
  );
};
